import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function MySuperLetter() {
  return <section data-section-id="223663" id="the-frontier-experience" className="bg-background text-foreground relative flex min-h-screen items-center justify-center overflow-hidden py-24 px-4 sm:px-6 lg:px-8">
      {}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -left-[10%] h-[70vw] w-[70vw] rounded-full bg-chart-1/5 blur-[120px] mix-blend-multiply animate-pulse" style={{
        animationDuration: '12s'
      }} />
        <div className="absolute -bottom-[20%] -right-[10%] h-[70vw] w-[70vw] rounded-full bg-chart-2/5 blur-[120px] mix-blend-multiply animate-pulse" style={{
        animationDuration: '15s',
        animationDelay: '3s'
      }} />
      </div>

      {}
      <Card className="relative z-10 w-full max-w-4xl border-none bg-transparent shadow-none overflow-hidden rounded-none">
        
        {}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-[0.04] text-foreground">
          <svg viewBox="0 0 100 100" fill="currentColor" className="w-[80%] h-[80%] max-h-full">
            <path d="M50 5 L95 25 L50 95 L5 25 Z" />
            <path d="M80 28 L50 15 L20 28 L50 80 Z" fill="var(--background)" />
            <path d="M70 32 C 40 20, 25 45, 50 55 C 75 65, 60 85, 30 75" fill="none" stroke="currentColor" strokeWidth="8" strokeLinecap="round" />
          </svg>
        </div>

        <CardContent className="p-8 sm:p-12 md:p-16 lg:p-20 relative z-20 flex flex-col items-center">
          <div className="prose prose-invert max-w-none">
            <p className="font-serif text-lg sm:text-xl md:text-2xl leading-loose text-foreground/80 tracking-normal text-center">
              <span className="float-left text-7xl sm:text-8xl md:text-9xl font-default text-chart-1 pr-4 pt-2 sm:pt-4 leading-none drop-shadow-none">
                S
              </span>
              mall-group motorbike journeys through the legendary Ha Giang Loop. Experience the frontier through our premium Easy Rider experience—a curated journey designed for those who seek the soul of the mountains in their most majestic form.
            </p>
          </div>
          <Link to="https://frontiernorthvietnam.com/reserve-your-seat/">
            <Button className="mt-10 px-8 py-6 text-lg uppercase tracking-widest font-sans" variant="default">CHECK AVAILABILITY</Button>
          </Link>
        </CardContent>
      </Card>
    </section>;
}